import OffCanvas from './offcanvas'
import Footer    from './footer'
import Product    from './product'
import ImageGrid    from './image-grid'

export default {
    OffCanvas,
    Footer,
    Product,
    ImageGrid
}
